<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <v-card
    flat
    class="secondary fill-height pa-12"
    height="25%">
    <v-list class="secondary" min-width="400px">
      <v-subheader class="display-1 grayBold--text">
        {{$t("delete_device")}}
      </v-subheader>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="subtitle-2 grayBold--text">
            {{$t("delete_device_warning")}}{{payload.device.device_id}}{{$t("question_mark")}} 
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        depressed
        right
        light
        color="grayBold--text secondary"
        @click="hideModal()"
      >
        {{$t("cancel")}} 
      </v-btn>
      <v-btn
        color="primary"
        depressed
        right
        large
        class="modal-logout"
        @click="doDeleteDevice"><v-icon left>mdi-delete</v-icon>{{$t("delete_for_uppercase")}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, installationsModule, devicesModule } from '@/store/modules/store-accessor'

@Component
export default class DeleteInstallationModal extends Vue {
  @Prop()
  payload!: any;

  async mounted() {
    commonModule.initSnackbar({});
  }

  async hideModal () {
    commonModule.hideModal();
  }

  async hideSideView() {
    commonModule.hideSideview();
  }

  async doDeleteDevice () {
    devicesModule.deleteDevice(this.payload.device);
    this.hideModal();
    devicesModule.unsetCurrentDevice();
    installationsModule.unsetCurrentInstallation();
    this.hideSideView();
  }
};
</script>
